import { BodyShort } from 'components/typography';
import React from 'react';
import { components } from 'react-select';
const ValueLabel = (props) => (React.createElement(components.MultiValueLabel, Object.assign({}, props),
    React.createElement(BodyShort, { size: props.size }, props.data.label || props.data.name)));
ValueLabel.displayName = 'SelectMultiple.ValueLabel';
export default ValueLabel;
